document.addEventListener("DOMContentLoaded", function () {

    //SEARCH TOGGLE
    var slideOpen = true;
    document.querySelector('#btn_search').addEventListener('click' , function() {
        var searchForm = document.querySelector('.search_form form');
        if(slideOpen) {
            slideOpen = false;
            searchForm.style.height = '35px';
            // searchForm.style.visibility = 'visible';
        }
        else {
            slideOpen = true;
            searchForm.style.height ='0px';
        }
    })
    //MENU TOGGLE
    if (window.screen.width < 900) {
        // ----- MENU -----
        var menu = document.querySelector('.main_header .menu_icon');
        menu.addEventListener('click', toggleMenu);
        function toggleMenu() {
            var menuForm = document.querySelector('#nav_toggle');
            if (menuForm.style.display === "block") {
                menuForm.style.display = "none"
                
            } else {
                menuForm.style.display = "block"
            }
        }
        // ----- END OF MENU -----
        // ----- SUB_MENU -----
        var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
        arrowIcon.forEach(function(i) {
            i.addEventListener('click' , toggleSubmenu);
            function toggleSubmenu(e) {
                e.stopPropagation();
                e.preventDefault();
                if (this.parentNode.children[2].style.display === "block") {
                this.parentNode.children[2].style.display = "none";
                } else {
                this.parentNode.children[2].style.display = "block";
                }
            }
        })
        // ----- END OF SUB_MENU -----
    }
    //---------GALLERY---------
        document.querySelectorAll('.splide').forEach(function (slider) {
            new Splide(slider, {
                direction: 'rtl',
                type: 'loop',
                focus: 'center',
                perPage: 1
            }).mount();
        });
    //--------SHORTLINK----------
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
        shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var $temp = document.createElement("input");
        document.body.appendChild($temp);
        $temp.value = shortLink.href;
        $temp.select();
        document.execCommand("copy");
        $temp.remove();
        document.querySelector(".tinyurl_copied").style.display = "block";
        setTimeout(function () {
            document.querySelector(".tinyurl_copied").style.display = "none";
        }, 1500);
        });
    }
    //--------INLINE ADV--------
    var countP = document.querySelectorAll('#echo_detail p:not(table p, blockquote p)');
    function insertBefore(newNode, dist) {
        dist.parentNode.insertBefore(newNode, dist)
    }

    // without else 
    //FIRST ADVERTISMENT // Before paragraph 2th
    if (countP.length > 2) {
        var adv = document.getElementById('inline_first_adv');
        insertBefore(adv, countP[2]);
    }

    // RESPONSIVE TABLE
    if (document.querySelector("#echo_detail")) {
        var tables = document.querySelectorAll("#echo_detail table");
        tables.forEach(function (table) {
          var parentTable = document.createElement('div');
          parentTable.classList.add("table_res");
          table.parentNode.replaceChild(parentTable, table);
          parentTable.appendChild(table);
        });
      }
    
       //----STICKY NOTIF----
  let closeNotif2 = false;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 600) {
      if (!closeNotif2) {
        const stickyNotify2 = document.querySelector('.sticky_notify2');
        if (stickyNotify2) {
          stickyNotify2.style.display = 'block';
        }
      }
    }
  });

  // Close sticky-notify
  window.closeStikyAd2 = function closeStikyAd2() {
    const stickyNotify2 = document.querySelector('.sticky_notify2');
    if (stickyNotify2) {
      stickyNotify2.style.display = 'none';
      closeNotif2 = true;
    }
  };

});
